export interface IAuthToken {
    session?: {
        accessToken: string;
        sessionType: 'anonymous' | 'authenticated';
        location: { countryCode: string; region: string };
    };
    handle?: string;
    identityGrant?: {
        grant: string;
    };
    username?: string;
}

export const getAuthTokenParsed = (authToken: unknown) => {
    return authToken as IAuthToken;
};
